import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { audio, audioPlayer, audioTitle } from './atom.audio.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AudioContent(props) {
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  return /*#__PURE__*/jsxs("div", {
    className: audio,
    children: [/*#__PURE__*/jsx(CircledAudioPlayer, {
      className: audioPlayer,
      src: props.src,
      size: isMobile ? undefined : "large"
    }), props.title?.trim() && /*#__PURE__*/jsx("span", {
      className: audioTitle,
      children: props.title
    })]
  });
}

export { AudioContent };
//# sourceMappingURL=atom.audio.js.map
